import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { onMounted } from "vue";
import { storeToRefs } from "pinia";
import { useScreenStore, useMainStore, useSnapshotStore } from "@/store";
import { LOCALSTORAGE_KEY_DISCARDED_DB } from "@/configs/storage";
import { deleteDiscardedDB } from "@/utils/database";
import { isPC } from "@/utils/common";

import Editor from "@/views/Editor/index.vue";
import Screen from "@/views/Screen/index.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const _isPC = isPC();

const mainStore = useMainStore();
const snapshotStore = useSnapshotStore();
const { databaseId } = storeToRefs(mainStore);
const { screening } = storeToRefs(useScreenStore());

if (process.env.NODE_ENV === "production") {
  window.onbeforeunload = () => false;
}

onMounted(async () => {
  await deleteDiscardedDB();
  snapshotStore.initSnapshotDatabase();
  mainStore.setAvailableFonts();
});

// 应用注销时向 localStorage 中记录下本次 indexedDB 的数据库ID，用于之后清除数据库
window.addEventListener("unload", () => {
  const discardedDB = localStorage.getItem(LOCALSTORAGE_KEY_DISCARDED_DB);
  const discardedDBList: string[] = discardedDB ? JSON.parse(discardedDB) : [];

  discardedDBList.push(databaseId.value);

  const newDiscardedDB = JSON.stringify(discardedDBList);
  localStorage.setItem(LOCALSTORAGE_KEY_DISCARDED_DB, newDiscardedDB);
});

function doRouter(path: string) {
  console.log(path);
}

return (_ctx: any,_cache: any) => {
  return (_unref(screening))
    ? (_openBlock(), _createBlock(Screen, { key: 0 }))
    : (_openBlock(), _createBlock(Editor, { key: 1 }))
}
}

})